import Actions, { types } from './actions';
import { AuthState } from '.';

const initialState: AuthState = {
  isAuth: false,
  roleScreen: null,
  roleScreenPath: '',
  roleScreenStatus: 'idle',
  roleScreenRequestId: '',
};

const reducer = (state = initialState, action: Actions): AuthState => {
  const newState = { ...state };
  switch (action.type) {
    case types.SET_IS_AUTH:
      newState.isAuth = action.payload;
      return newState;
    case types.SET_ROLE_SCREEN:
      newState.roleScreen = action.payload;
      return newState;
    case types.REQUEST_ROLE_SCREEN:
      newState.roleScreenPath = action.payload.path;
      newState.roleScreenStatus = 'loading';
      newState.roleScreenRequestId = action.payload.requestId;
      return newState;
    case types.RESOLVE_ROLE_SCREEN:
      if (
        state.roleScreenPath !== action.payload.path ||
        state.roleScreenRequestId !== action.payload.requestId
      ) {
        return state;
      }
      newState.roleScreen = action.payload.roleScreen;
      newState.roleScreenStatus = 'ready';
      return newState;
    case types.FAIL_ROLE_SCREEN:
      if (
        state.roleScreenPath !== action.payload.path ||
        state.roleScreenRequestId !== action.payload.requestId
      ) {
        return state;
      }
      newState.roleScreenStatus = 'error';
      return newState;
    default:
      return state;
  }
};

export default reducer;
